import React, { memo } from "react";
import { BaseEdge, useStore } from "reactflow";

function getRect(n) {
  if (!n) return null;
  const x = n.positionAbsolute?.x ?? n.position?.x;
  const y = n.positionAbsolute?.y ?? n.position?.y;
  const w = n.width ?? n.measured?.width;
  const h = n.height ?? n.measured?.height;
  if (x == null || y == null || w == null || h == null) return null;
  return { left: x, right: x + w, top: y, bottom: y + h, cy: y + h / 2, h };
}

export const TopManualEdge = memo(function TopManualEdge(props) {
  const { id, source, sourceY, targetX, markerEnd, style, data } = props;

  const nodeInternals = useStore((s) => s.nodeInternals);
  const sNode = nodeInternals.get(source);
  const s = getRect(sNode);

  const OUT = 35;
  const R = typeof data?.radius === "number" ? data.radius : 5;

  const topRowY = typeof data?.topCorridorY === "number" ? data.topCorridorY : 0;
  const nodeH = typeof data?.nodeH === "number" ? data.nodeH : (s?.h ?? 36);
  const viaY = topRowY + nodeH / 2;

  const x0 = s?.right ?? 0;
  const y0 = s?.cy ?? sourceY;

  const x1 = x0 + OUT;

  const vDir = viaY < y0 ? -1 : 1;

  const maxR1 = Math.max(0, Math.min(R, Math.abs(viaY - y0) / 2, OUT / 2));
  const r = maxR1;

  const d = [
    `M ${x0} ${y0}`,
    `L ${x1 - r} ${y0}`,
    `Q ${x1} ${y0} ${x1} ${y0 + vDir * r}`,
    `L ${x1} ${viaY - vDir * r}`,
    `Q ${x1} ${viaY} ${x1 + r} ${viaY}`,
    `L ${targetX} ${viaY}`,
  ].join(" ");

  return <BaseEdge id={id} path={d} markerEnd={markerEnd} style={style} />;
});
